import React from "react";

export const SnackbarContext = React.createContext<
  (message: string, url?: string) => void
>(() => {
  console.log("Snackbar context is not defined. Please use context provider.");
});
